<template lang="pug">
div
    mixin product(product)
        div.row
            div.col-xs-5
                small {{ orderProductName(product) }}
            div.col-xs-2
                small.pull-right @{{ product.unit_price }}&nbsp;
            div.col-xs-2
                small.pull-right x{{ product.quantity }}
            div.col-xs-3
                small.pull-right {{ orderProductPrice(product) }}

    mixin promotionProduct(promotion)
        div.row.grand-total-amount
            div.col-xs-11
                small._500 {{ promotion.promotion_name }}
            div.col-xs-1
                small.pull-right._500 x{{ promotion.promotion_quantity }}

        div(v-for="product in promotion.products")
            div.row
                div.col-xs-5
                    small {{ orderProductName(product) }}
                div.col-xs-2
                    small.pull-right @{{ product.promotionPrice }}&nbsp;
                div.col-xs-2
                    small.pull-right x{{ product.quantity }}
                div.col-xs-3
                    small.pull-right {{ product.totalPromotionPrice }}

            div.row
                div.col-xs-7
                    small.pull-right (Normal Price: @{{ product.unit_price }})

    .row(v-if="cancelledOrderProducts.length")
        .col-xs-12
            small.dark.block.text-center.m-b-sm Cancelled Items

    div(v-for="product in cancelledOrderProducts")
        +product(product)

    .row(v-if="purchasedOrderProducts.length || modifyPurchasedPromotionOrderProducts.length")
        .col-xs-12
            small.dark.block.text-center.m-y-sm Purchased Item(s)

    div(v-for="product in purchasedOrderProducts")
        +product(product)

    div(v-for="promotion in modifyPurchasedPromotionOrderProducts")
        +promotionProduct(promotion)

    div.row(v-if="orderProducts.length")
        div.col-xs-12
            hr
</template>

<script>
import receiptMixin from '../../mixins/receipt';
import StoreMixin from './store-mixin';
import { mapGetters } from 'vuex';

export default {
    mixins: [receiptMixin, StoreMixin],

    computed: {
        ...mapGetters('transaction', [
            'receipt',
            'hasTransaction',
            'isVoided',
            'outlet',
            'table',
            'orderTable',
            'orderProducts',
            'cashier',
            'cancelledOrderProducts',
            'purchasedOrderProducts',
            'purchasedPromotionOrderProducts',
        ]),

        modifyPurchasedPromotionOrderProducts() {
            return this.purchasedPromotionOrderProducts.map(promotion => {
                let products = promotion.products.map(product => {
                    product.promotionPrice = this.orderProductModifierPriceV2(
                        product.modifier,
                        product,
                    );

                    product.totalPromotionPrice = this.orderProductPriceV2(
                        product.modifier,
                        product,
                    );

                    return product;
                });

                let sumAmount = products
                    .map(product => parseFloat(product.amount))
                    .reduce((a, b) => a + b)
                    .toFixed(2);

                let sumTotalPromotionPrice = products
                    .map(product => parseFloat(product.totalPromotionPrice))
                    .reduce((a, b) => a + b)
                    .toFixed(2);

                if (sumAmount !== sumTotalPromotionPrice) {
                    let difference = (
                        sumAmount - sumTotalPromotionPrice
                    ).toFixed(2);

                    products[0].promotionPrice = (
                        parseFloat(products[0].promotionPrice) +
                        parseFloat(difference)
                    ).toFixed(2);

                    products[0].totalPromotionPrice = (
                        parseFloat(products[0].totalPromotionPrice) +
                        parseFloat(difference)
                    ).toFixed(2);
                }

                return promotion;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.voided {
    font-size: 14px;
    vertical-align: middle;
}
.grand-total-amount {
    border: 1px solid #666;
    border-radius: 10px;
    margin-left: 0;
    margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/receipt/orders.vue